/*
 * Title: Auth/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Auth component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import logo from "@assets/logo.png";
import check from "@assets/close.png";
import store from "@store/configureStore";
import { useNavigate } from "react-router-dom";

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!store.getState().loader.resolver) {
      navigate("/");
    }
  });

  return (
    <div
      className={`absolute grow w-full transition-all duration-1000 ease-in-out h-full text-center flex flex-col`}>
      <div className="getStarted">
        <div className="lg:bg-[#fff]/80 bg-[#fff]/70 h-full">
          <div className="flex flex-col h-full py-10 2xl:py-16 2xl:pb-5">
            <div className="bg-white shadow-xl max-w-[430px] w-full px-10 py-10 rounded-[25px] mx-auto flex lg:justify-between justify-around flex-col">
              <div>
                <div className="border-2 bg-[#FF0000] p-2 border-[#FF0000] mx-auto h-[38px] w-[38px] rounded-full">
                  <img
                    src={check}
                    alt="check"
                    className="object-contain w-full h-full"
                  />
                </div>
                <p className="font-medium text-[16px] mt-[15px]">
                 {(store.getState().loader?.error)}
                </p>
                <p className="font-normal text-gray-700 text-[16px] mt-[8px]">
                  Go back to your original tab.
                </p>
                <p className="font-normal text-gray-600 text-[14px] mt-[35px]">
                  You can close this window.
                </p>
                <div className="flex flex-col items-center justify-center gap-y-1 mt-[25px]">
                  <p className="font-normal primary text-[11px] tracking-[2px]">
                    Powered by
                  </p>
                  <a
                    target={"_blank"}
                    rel="noreferrer noopener"
                    href="https://encore.fans/">
                    <img
                      src={logo}
                      alt="logo"
                      className="h-[25px] w-[140px] object-contain"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="flex items-end justify-center lg:grow-2 grow"></div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
